import React from "react";

const SectionHeader = ({ index, eyebrow, title, kicker, align = "left" }) => {
  return (
    <div className={`mb-10 md:mb-16 ${align === "center" ? "text-center" : ""}`}>
      <div className="flex items-center gap-3 font-mono text-[11px] text-muted-foreground uppercase tracking-widest">
        {index && <span>{index}</span>}
        <span className="h-px w-10 bg-foreground/40" />
        <span>{eyebrow}</span>
      </div>
      <h2 className="display-xl text-4xl md:text-6xl mt-4 leading-[0.95]">{title}</h2>
      {kicker && (
        <p className="mt-5 text-muted-foreground max-w-2xl text-base md:text-lg leading-relaxed">
          {kicker}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
